import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const PredictionHistoryContext = createContext()

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const startDate = new Date(currentYear, currentMonth, 1)

export const PredictionHistoryProvider = ({ children }) => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [dateRange, setDateRange] = useState([startDate, new Date()])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [onShift, setOnShift] = useState('Sim')
  const [inputValue, setInputValue] = useState('')
  const [graphMessage, setGraphMessage] = useState(null)

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getPredictionHistory({
        date: dateRange,
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
        onShift,
      })

      setRows(data?.data)
      setGraphMessage(data?.graphMessage)
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getPredictionHistoryFilters()

      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [dateRange, selectedFilterOptions, selectedUser?.id, onShift])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <PredictionHistoryContext.Provider
      value={{
        rows,
        loading,
        dateRange,
        onDateRangeChange: setDateRange,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        onShift,
        onCheckOnShift: setOnShift,
        selectedUser,
        onSelectUser,
        inputValue,
        onInputValueChange: setInputValue,
        graphMessage,
      }}
    >
      {children}
    </PredictionHistoryContext.Provider>
  )
}

export const usePredictionHistory = () => {
  return useContext(PredictionHistoryContext)
}
